import type { BrandConfigurationFactory } from '../common/interfaces/BrandConfigurationFactory';
import enGB from './locale/en-GB.json';

// TODO: configure this brand properly
export const ourHabitasBrandConfig: BrandConfigurationFactory = ({
  isProduction,
}) => ({
  chainCode: 'ourhabitas',
  themeKey: 'ourhabitas',
  name: 'Our Habitas',
  hotels: [
    {
      referenceId: 'ourhabitas.test-test',
      code: 'ourhabitas.test-test',
      name: 'Our Habitas',
      dialect: 'ohip',
    },
  ],
  homeUrl: 'https://www.ourhabitas.com',
  domains: [
    'booking.ourhabitas.com',
    'ourhabitas.ui.dev.ennismore.io',
    'ourhabitas.ui.staging.ennismore.io',
    'ourhabitas.ui.live.ennismore.io',
  ],
  i18n: {
    locales: ['en-GB'],
  },
  maxRoomCountPerBooking: 3,
  supportedRoomOccupancyConfigurations: [{ adults: 1 }, { adults: 2 }],
  legal: {
    urls: {
      en: {
        privacyPolicy: 'https://google.com',
        cookiePolicy: 'https://google.com',
        termsOfUse: 'https://google.com',
        contact: 'https://google.com',
      },
    },
  },
  showRoomTotalInBreakdown: false,
  showTaxTotalInBreakdown: false,
  showInlineCalendar: false,
  features: {
    bookingManagement: false,
  },
  translationOverrides: {
    'en-GB': enGB,
  },
  analytics: {
    gtm: {
      containerId: isProduction ? '' : '',
    },
    cookieConsent: {
      provider: 'onetrust',
      oneTrustId: '',
    },
  },
});
